import { render, staticRenderFns } from "./FeedbackRegular.vue?vue&type=template&id=b05bd8c6&scoped=true&"
import script from "./FeedbackRegular.vue?vue&type=script&lang=js&"
export * from "./FeedbackRegular.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackRegular.vue?vue&type=style&index=0&id=b05bd8c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05bd8c6",
  null
  
)

export default component.exports